import type { ReactElement } from 'react';
import { cn } from '@/lib/utils';
import {
    DEFAULT_EDITORIAL_HEADING_CLASS_ID,
    resolveEditorialHeadingClass,
    resolveEditorialHeadingType,
    type EditorialHeadingClassId,
    type EditorialHeadingTypeId,
} from '@/components/editorial-heading-tag/editorial-heading-map';

export interface EditorialHeadingTagProps {
    /**
     * Text rendered inside the heading element.
     */
    children: string;
    /**
     * Semantic HTML heading tag (`h1`–`h6`).
     * @default 'h3'
     */
    headingTypeTitle?: EditorialHeadingTypeId;
    /**
     * Page Designer typography token mapped to a CSS heading class.
     * @default 'Heading Headline M'
     */
    headingClassTitle?: EditorialHeadingClassId;
    /**
     * Class to apply to the heading.
     */
    className?: string;
}

/**
 * Renders an editorial heading with a configurable semantic tag and typography class.
 */
export function EditorialHeadingTag({
    children,
    headingTypeTitle,
    headingClassTitle = DEFAULT_EDITORIAL_HEADING_CLASS_ID,
    className,
}: EditorialHeadingTagProps): ReactElement {
    const HeadingTag = resolveEditorialHeadingType(headingTypeTitle);
    const headingClass = resolveEditorialHeadingClass(headingClassTitle);
    return <HeadingTag className={cn(headingClass, className)}>{children}</HeadingTag>;
}
